module.exports = __webpack_public_path__ + "img/money.2577bd1f.png";